import { SystemStyleObjectRecord } from "@chakra-ui/react";

const textStyles: SystemStyleObjectRecord = {
  h1: {
    fontSize: "5xl",
    fontWeight: "semibold",
    lineHeight: 14,
  },
  h2: {
    fontSize: "4xl",
    fontWeight: "semibold",
    lineHeight: 10,
  },
  h3: {
    fontSize: "2xl",
    fontWeight: "semibold",
    lineHeight: 8,
  },
  h4: {
    fontSize: "lg",
    fontWeight: "semibold",
    lineHeight: "6.5",
  },
  body: {
    fontSize: "md",
    lineHeight: 6,
  },
  body2: {
    fontSize: "sm",
    lineHeight: "5.5",
  },
  cta: {
    fontSize: "sm",
    fontWeight: "semibold",
    lineHeight: 4,
  },
  ctaSmall: {
    fontSize: "xs",
    fontWeight: "semibold",
    lineHeight: 4,
  },
  label: {
    fontSize: "sm",
    fontWeight: "bold",
    lineHeight: 4,
  },
  label2: {
    fontSize: "sm",
    fontWeight: "semibold",
    lineHeight: 4,

    color: "grey.600",
  },
  labelSmall: {
    fontSize: "tiny",
    fontWeight: "semibold",
    lineHeight: 3,

    color: "grey.600",
  },
  caption: {
    fontSize: "xs",
    fontWeight: "semibold",
    lineHeight: 5,
  },
};

export default textStyles;
